import { useDispatch, useSelector } from 'react-redux';

import { setHistoryCreateSurvey, setStepCreateSurvey } from 'store/actions/survey';

const useCreateSurvey = () => {
  const dispatch = useDispatch();
  const { history_create_survey, step_create_survey } = useSelector((state) => state.survey);

  const onSaveStep = (values) => {
    const dataString = JSON.stringify(values);
    const historyString = history_create_survey[step_create_survey];

    let newHistory = history_create_survey ?? [];

    if (historyString !== dataString) {
      if (step_create_survey < history_create_survey.length - 1) {
        if (step_create_survey === 0) {
          newHistory = history_create_survey.slice(0, 1);
        } else {
          newHistory = history_create_survey.slice(0, step_create_survey + 1);
        }
      }
      newHistory.push(dataString);
      dispatch(setHistoryCreateSurvey([...newHistory]));
      dispatch(setStepCreateSurvey(newHistory.length - 1));
    }
  };

  return { onSaveStep };
};

export default useCreateSurvey;
